const endpoints = {
  organizationSlug: 'organizations/check-slug',
  register: 'organizations/register',
  verifyCoupon: 'organizations/coupons/verify',
  subscriptionPlans: 'organizations/subscription-tiers',
  requestProductDemo: 'request-product-demo',
}

export default endpoints
